import React from "react";
import style from "./StoreButtons.module.css";
import PropTypes from "prop-types";
import googleplayIcon from '../../assets/Images/googleplayIcon.svg';

export default function GooglePlay({ appLink }) {
  return (
    <a className={`${style.appBtn} ${style.blu} ${style.flex}`} href={appLink}>
      <img  className={`${style.appIcon} ${style.icon} mr-2`} src={googleplayIcon} />
      <p className={style.btnBox}>
        <span className={style.smallTxt}> Get it on </span>
        <br />
        <span className={`${style.bigTxt}`}>Google Play</span>
      </p>
    </a>
  );
}

GooglePlay.propTypes = {
  appLink: PropTypes.string,
};
